import React from 'react';
import HeroSection from '../components/home/HeroSection';
import TrustBar from '../components/home/TrustBar';
import ServicesGrid from '../components/home/ServicesGrid';
import ReviewsSection from '../components/home/ReviewsSection';
import WhyChooseUs from '../components/home/WhyChooseUs';
import ServiceAreaSection from '../components/home/ServiceAreaSection';
import FinalCTA from '../components/home/FinalCTA';
import MobileStickyCTA from '../components/home/MobileStickyCTA';
import PageSeo from '../components/shared/PageSeo';
import { PAGE_SEO } from '../data/seo';

const HomePage = () => (
  <main>
    <PageSeo {...PAGE_SEO.home} />
    <HeroSection />
    <TrustBar />
    <ServicesGrid />
    <WhyChooseUs />
    <ReviewsSection />
    <ServiceAreaSection />
    <FinalCTA />
    <MobileStickyCTA />
  </main>
);

export default HomePage;
